/*
 * @Description: 数据分析伪代码公用方法实现
 * @Author: shenah
 * @Date: 2023-04-11 17:04:43
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:34:06
 */
function customSort(sortArrStr, originArr, field) {
  let sortArrStrLength = sortArrStr.length;
  let beforeArr = new Array(sortArrStrLength);
  let diffArr = [];
  originArr.forEach((item) => {
    let sortArrIndex = sortArrStr.indexOf(item[field]);
    if (sortArrIndex > -1) {
      beforeArr[sortArrIndex] = item;
    } else {
      diffArr.push(item);
    }
  });
  beforeArr = beforeArr.filter(Boolean);
  return [...beforeArr, ...diffArr];
}
function judgeSortType(str) {
  if (Array.isArray(str)) {
    return "array";
  }
  let strNum = Number(str);
  if (str === "升序" || strNum === 1) {
    return "asc";
  } else if (str === "降序" || strNum === -1) {
    return "desc";
  }
  return "default";
}
export default {
  // 刷新方法
  refreshDataEvent() {
    this.init();
    return this;
  },
  // 根据条件筛选出数据
  filterConditionData(str, col) {
    if (
      ["dsf-large-screen-table", "scroll-board"].indexOf(this.componentRef) > -1
    ) {
      return this.generalTableFilterConditionData(str, col);
    }
    return this.data.filter((item) => this.$eval(str, item));
  },
  // 添加数据
  appendDataEvent(data) {
    if (Array.isArray(this.data)) {
      if (Array.isArray(data)) {
        this.data.push([...data]);
      } else {
        this.data.push(data);
      }
      this.extraSpecialRender();
    }
    return this;
  },
  /**
   * @description: 删除数据
   *@param {string | number} sort 下标(传入1就是删除第一个,依次类推)删除、以及名称删除
   * @param {string} field 支持传入动态字段
   */
  delDataEvent(str, field = "name") {
    if (Array.isArray(this.data)) {
      let isNumber = typeof str === "number";
      let argLength = [...arguments].filter(
        (item) => item !== undefined && item !== null
      ).length;
      let index = 0;
      if (isNumber && argLength === 1) {
        index = str - 1;
      } else {
        index = this.data.findIndex((item) => item[field] == str);
        if (index === -1) {
          return this;
        }
      }
      this.data.splice(index, 1);
      this.extraSpecialRender();
    }
    return this;
  },
  /**
   * @description: 数据排序
   * @param {string | number} sort 支持1(升序)、-1(降序)
   * @param {string} field 支持对于字段排序
   */
  // 数据排序
  dataSortEvent(sort, field = "value") {
    if (!sort && sort !== 0) {
      return this;
    }
    let data = this.data;
    let type = judgeSortType(sort);
    if (type === "default") {
      return this;
    } else if (type === "array") {
      this.data = customSort(sort, this.data, field);
      this.extraSpecialRender();
      return this;
    }

    let isNumber = this.data.every(
      (item) =>
        (item[field] !== null || item[field] !== undefined) &&
        dsf.isNumber(item[field])
    );
    if (isNumber) {
      data = data.map((item) => ({
        ...item,
        [field]: item[field] ? Number(item[field]) : 0,
      }));
    }
    this.data = _.orderBy(data, field, type);
    this.extraSpecialRender();

    return this;
  },
  // 还原数据
  resetDataEvent() {
    // this.data = _.cloneDeep(this.pureData);
    // if (this.componentType === 'generalTable') {
    //   this.header = _.cloneDeep(this.pureHeader);
    // }
    // 调用刷新的方法
    this.refreshDataEvent();
    return this;
  },
  setDataEvent(data) {
    //目前就只有时间线有这个方法
  },
  getCurrentDataEvent(data) {
    //目前就只有时间线有这个方法
  },
};
